import Icon from '@assets/images/Hero-Icone.png';
import { Link } from 'react-router-dom';
import {
  SectionWrapper,
  StyledHr,
  ContentWrapper,
  TextBox1,
  TextBox2,
  ImageBox,
  SectionContainer,
} from './SectionSeven.style';
import { useTranslation } from 'react-i18next';

const SectionSeven = () => {
  const { t } = useTranslation('home');
  return (
    <SectionContainer>
      <SectionWrapper>
        <h1>
          {t('sectionSeven.title')}
          <span>2</span> AI
        </h1>
        <StyledHr />
      </SectionWrapper>

      <ContentWrapper>
        <TextBox1>
          <p>{t('sectionSeven.paragraphOne')}</p>
          <Link to="/contato" className="link-with-icon">
            <button>{t('sectionSeven.button')}</button>
          </Link>
        </TextBox1>

        <ImageBox>
          <img src={Icon} alt="Imagem" />
        </ImageBox>
      </ContentWrapper>
    </SectionContainer>
  );
};

export default SectionSeven;
